
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { StandRoutingModule } from './stand-routing.module';
import { StandComponent } from './stand.component';



import { NgScrollbarModule } from 'ngx-scrollbar';
import { StandFooterModule } from './components/footer/stand-footer.module';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
    CommonModule,
    RouterModule,
    StandRoutingModule,
    NgScrollbarModule,
    MatButtonModule,
    StandFooterModule,
    StandComponent
]
})

export class StandModule
{
}
